<template>
  <v-card v-if="logs">
    <v-card-title>
      Logs
      <v-spacer></v-spacer>
      <v-btn depressed small color="success" @click="getLogs()">laden</v-btn>
      <v-spacer></v-spacer>
      <v-text-field 
        v-model="start" 
        label="van"
        hide-details
        single-line 
      ></v-text-field>
      <v-spacer></v-spacer>
      <v-text-field 
        v-model="end" 
        label="tot"
        hide-details
        single-line 
      ></v-text-field>
      <v-spacer></v-spacer>
      <v-select 
        hide-details
        single-line 
        label="Level" 
        v-model="level"
        :items="logLevels"></v-select>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="logs"
      :items-per-page="100"
      class="elevation-1"
      :search="search"
      dense>
      <template v-slot:item.timeStamp="{ item }">
        <span>{{ $moment.utc(item.timeStamp).local().format("DD-MM-YYYY HH:mm:ss") }}</span>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
export default {
  name: "SettingsSystemLog",
  data() {
    return {
      search: "",
      start: this.$moment().add(-30, 'minutes').format("DD-MM-YYYY HH:mm:ss"),
      end: this.$moment().format("DD-MM-YYYY HH:mm:ss"),
      logs: null,
      logLevels: ['Verbose', 'Debug', 'Information', 'Warning', 'Error', 'Fatal'],
      level: 'Information',
      headers: [
        { text: "Datum/Tijd", value: "timeStamp", sortable: true, width: 170  },
        { text: "Level", value: "level", sortable: true },
        { text: "Melding", value: "message", sortable: false}
      ],
    };
  },
  watch: {
    level() {
      this.getLogs()
    }
  },
  methods: {
    getLogs() {
      this.$http
        .get("api/system/log?level=" + this.level + "&start=" + this.$moment(this.start, "DD-MM-YYYY HH:mm:ss").toISOString() + "&end=" + this.$moment(this.end, "DD-MM-YYYY HH:mm:ss").toISOString())
        .then(request => {
          if (request.status == 200) {
            this.logs = request.data;
          }
        })
        .catch((e) => {
          this.$root.$children[0].$emit("display-error", "2300", e);
        });
    }
  },
  mounted() {
    this.getLogs();
  }
};
</script>